const initSwiperGallery = (Swiper) => {
    const thumbSwiper= new Swiper(".thumbSlider", {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 3,
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 640px
            640: {
                slidesPerView: 4
            },
            // when window width is >= 1024px
            1024: {
                slidesPerView: 5
            }
        },
        freeMode: true,
        watchSlidesProgress: true,
    });
    new Swiper(".mainSlider", {
        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: thumbSwiper,
        }

    });
};

export default initSwiperGallery;